import VerificationBar from './VerificationBar';

export default VerificationBar;
